import Cookies from "js-cookie";
import { v7 as uuidv7 } from "uuid";

export const deviceInfoCache = () => {
  try {
    const deviceId = Cookies.get('deviceId')
    if (deviceId) return deviceId
    const newDeviceId = uuidv7();
    Cookies.set('deviceId', newDeviceId);
    return newDeviceId;
  } catch (error) {
    return uuidv7();
  }
}
